import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './CommunityCard.css';
// import {connect} from 'react-redux';

class CommunityCard extends Component {
	render() {
		if (!this.props.community) return null;

		const {
			community: {
				name,
				approvedCount,
				profile: {backgroundImage, backgroundPosition, uniqueName, state},
				location,
				sessionProvider
			},
			enableLink = true,
			linkToMembers = true,
			className,
			disabled = false,
			onClick,
			children
		} = this.props;

		const style = {
			backgroundImage: backgroundImage ? `url("/api/image/${backgroundImage}")` : undefined,
			backgroundPosition: `center ${backgroundPosition}%`
		};

		const cardDetails = [
			<h2 key="name" className={name && name.length > 30 ? 'long' : ''}>
				{name}
			</h2>,
			<div key="location" className="CommunityCard-location">
				<span className="icon icon-room" />
				&nbsp;
				<span>{location && location.suburb}</span>
			</div>,
			<div key="member" className="CommunityCard-member-count">
				{state === 'unapproved' && (
					<React.Fragment>
						<span>UNAPPROVED</span>
						&nbsp;
					</React.Fragment>
				)}
				<span className="icon icon-people" />
				&nbsp;
				<span>{approvedCount}</span>
			</div>,
			children
		];

		return (
			<li className={`CommunityCard ${className || ''}`}>
				{enableLink ? (
					<Link to={linkToMembers ? `/members/${uniqueName}` : `/!${uniqueName}`} style={style}>
						{cardDetails}
					</Link>
				) : (
					<div style={style} onClick={onClick} className={disabled ? 'disabled-card' : ''}>
						{cardDetails}
					</div>
				)}
			</li>
		);
	}
}

// const ConnectedCommunityCard = connect(
// 	state => ({
// 		sessionProvider: state.session && state.session.current
// 	})
// )(CommunityCard);

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/community/CommunityCard.js